import React, { useState } from "react";
import { doc, getDoc } from "firebase/firestore";

export default function AccessCodeGate({ db, onUnlocked }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const verify = async () => {
    setErr("");
    setLoading(true);

    try {
      const cleaned = String(code || "").trim().toUpperCase();
      if (!cleaned) throw new Error("Enter your access code.");

      const ref = doc(db, "accessCodes", cleaned);
      const snap = await getDoc(ref);

      if (!snap.exists()) throw new Error("Invalid access code.");

      const data = snap.data();

      if (data.status !== "active") throw new Error("This code is not active.");
      if (data.entitlement !== "lifetime-host") throw new Error("This code is not host-enabled.");

      // Optional product check (uncomment if you want strict matching)
      // const okProduct = data.product === "LineDanceBingo" || data.product === "Bundle";
      // if (!okProduct) throw new Error("This code is not for LineDance Bingo.");

      // Save for refresh persistence
      localStorage.setItem("OTB_HOST_CODE", cleaned);
      localStorage.setItem("OTB_HOST_PRODUCT", data.product || "Unknown");

      onUnlocked({ code: cleaned, data });
    } catch (e) {
      setErr(e.message || "Could not verify code.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="join-screen" style={{ maxWidth: 520, margin: "20px auto" }}>
      <h2>Host Access</h2>
      <p>Enter your access code to unlock the host dashboard.</p>

      <input
        placeholder="OTB-XXXX-XXXX"
        value={code}
        onChange={(e) => setCode(e.target.value)}
      />

      <button onClick={verify} disabled={loading}>
        {loading ? "Checking..." : "Unlock Host Dashboard"}
      </button>

      {err && <p style={{ color: "crimson", marginTop: 10 }}>{err}</p>}
    </div>
  );
}

